import Icon from './Icons'
import { MessageWrapper } from './HotDealMessage.styles'

const HotDealMessage: React.FC<{ message: string }> = ({ message }) => {
  return (
    <MessageWrapper className="hot-deal-wrapper">
      <Icon name="flame" fill="var(--sale)" />
      <span>{message}</span>
    </MessageWrapper>
  )
}

export default HotDealMessage
